import { createReducer, on } from '@ngrx/store';
import { setUser, clearUser } from './user.actions';
import { initialUserState } from './user.state';

export const userReducer = createReducer(
  initialUserState,
  on(setUser, (state, { user }) => ({ ...state, currentUser : user })),
  on(clearUser, state => ({ ...state, currentUser : null }))
);
